<template>
    <v-container fluid>
        <p v-html="$t('webboxes.data.text[0]')"></p>
        <code-block language="html" :code="code" as-text>
        </code-block>
        <p v-html="$t('webboxes.data.text[1]')"></p>
        <code-block language="javascript" :code="results" as-text>
        </code-block>
    </v-container>
</template>
<script>
  import CodeBlock from "@/components/CodeBlock"

  export default {
    name: 'RawData',
    components: { CodeBlock },
    data() {
      return {
        /* eslint-disable no-useless-escape */
        code:`<script>
window.addEventListener('DOMContentLoaded', function() {roi.getRecommendations({ 
    fields: ['image', 'price', 'description'], // fields retrieved from DreamROI - name and url are retrieved every time
    count: 10, // number of items - maximum is 15
    cart: false, // set to true if items in cart should be omitted
    utm: { campaign: 'customBox' }, // you can set your desired UTM campaign added to product links
    callback: function(results) {
      // TODO replace with your callback function
      document.getElementById('rec').innerText = JSON.stringify(results);
    }}) 
});
<\/script>
`,
  /* eslint-enable no-useless-escape */
      results:`var results = [
  {
    id:"internal DreamROI product ID",
    originalId: "ID sent in the product product feed"
    url:"product URL with UTM parameters",
    name:"...",
    price: 123, // number
    salePrice: 120, // number
    description: "...",
    image: "...", // just the filename
    imageUrl:"...", // whole URL
    personalized: true /* if set to false, the product is recommended to the user based on its popularity */
  },
  /* ... */
]`
      };
    },
    computed: {
    },
    methods: {
    },
  }
</script>